














































import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import "./jury-modal-change-category.less";
import {getAllVoted} from "@/services/getProjectData/getProjectData";
import {dataService} from "@/services/data/data-service";
import SimpleDropdownComponent from "../simple-dropdown/simple-dropdown.vue";
import {getLifechallengeCategoryBaseUrl} from "@/services/getCategoryData/getCategoryData";
import {getVote} from "@/services/webclient/webclient";


@Component({
  components: {
    SimpleDropdownComponent
  }
})
export default class juryModalChangeCategory extends Vue {
  @Prop() year;
  @Prop() juryModalVisible;
  @Prop() lifeChallengeCategory;

  private data = {
    juryModalVisible: false,
    lifeChallengeCategory: 0,
  };
  private category = {
    id: 0,
    name: "Please select a category to continue",
    url: ""
  };
  private categories :any;
  private categoryId = 0;
  private backtoUrl = "";

  mounted() {
    this.data.juryModalVisible = this.juryModalVisible;
    this.data.lifeChallengeCategory = this.lifeChallengeCategory;
    // this.categoryId= this.lifeChallengeCategory;
    this.categories = this.getCategories();


    setTimeout(()=>{
      getVote(this.year, this.data.lifeChallengeCategory).then( data =>{
        $.each(data.projects, function (index, project) {
          $.each(data.voted, function (index, vote) {
              if(project.id == vote.id){
                project['vote'] = vote.vote;
              }
          })
        });
        $.each(data.projects, (index, project)=>{
          if(typeof project.vote == "undefined"){
            this.backtoUrl = project.life_details_url;
            return false;
          }
        });
      }).catch(err => console.log(err))
    }, 500);



  }
  updated() {
    this.data.juryModalVisible = this.juryModalVisible;
    this.data.lifeChallengeCategory = this.lifeChallengeCategory;
  }
  getAllVoted(){
    return getAllVoted()
  }

  trans(key) {
    return translate(key);
  }

  getCategories() {
    return dataService.categories;
  }
  getCategory() {
    return dataService.categoryData.category;
  }
  closeModal() {
    this.data.juryModalVisible = false;
    this.onSettingJuryModalVisible(false);
  }
  backToThisCategory() {
    if(this.backtoUrl != ""){
      window.location.href = this.backtoUrl;
      return true;
    }else{
      setTimeout(()=>{
        this.backToThisCategory();
      }, 200)
    }

  }
  @Watch("juryModalVisible", { immediate: true, deep: true })
  onVisible(juryModalVisible) {
    this.data.juryModalVisible = juryModalVisible;
  }
  @Watch("index", { immediate: true, deep: true })
  onIndex(index) {
  }
  @Watch("category", { immediate: true, deep: true })
  onChangeCategory(category) {
    if(this.category.id !=0){
      window.location.href = getLifechallengeCategoryBaseUrl()+'/'+category.url;
    }
  }

  @Emit("settingJuryModalVisible")
  onSettingJuryModalVisible(value) {}
}
